import { render, staticRenderFns } from "./ph-news-detail.vue?vue&type=template&id=13b61b56&scoped=true"
import script from "./ph-news-detail.vue?vue&type=script&lang=js"
export * from "./ph-news-detail.vue?vue&type=script&lang=js"
import style0 from "./ph-news-detail.vue?vue&type=style&index=0&id=13b61b56&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b61b56",
  null
  
)

export default component.exports